import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { AuthStore, IAuthStore } from '../auth-store/AuthStore';
import { CommonCdStore, ICommonCdStore } from '../common-cd-store/CommonCdStore';
import { withEnvironment } from '../extensions/withEnvironment';
import { ILoadingStore, LoadingStore } from '../loading-store/LoadingStore';
import { ISnackbarStore, SnackbarStore } from '../snackbar-sore/SnackbarStore';

export const RootStoreModel = types
  .model('RootStore')
  .props({
    loadingStore: types.optional(LoadingStore, {} as ILoadingStore),
    snackbarStore: types.optional(SnackbarStore, {} as ISnackbarStore),
    authStore: types.optional(AuthStore, {} as IAuthStore),
    commonCdStore: types.optional(CommonCdStore, {} as ICommonCdStore),
  })
  .extend(withEnvironment);

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
